import apis from "../../core/apis.js";

class InvoiceItemTypeResource {
  constructor($resource, Upload) {
    "ngInject";

    this.$resource = $resource;
    this.Upload = Upload;
  }

  getAll(options) {
    return this.$resource(apis.invoiceItemType).get(options);
  }

  get(id, options) {
    return this.$resource(apis.invoiceItemType + id).get(options);
  }

  search(search = "") {
    return this.$resource(apis.invoiceItemType).get({ search });
  }

  post(item) {
    return this.$resource(apis.invoiceItemType).save(item);
  }

  update(id, item) {
    return this.$resource(apis.invoiceItemType + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  queryAll(options) {
    return this.$resource(apis.invoiceItemType + "dropdown").query(options);
  }

  // File Transaction
  uploadTransactionFile(data) {
    const url = apis.invoiceItemFileTransaction;
    const request = this.Upload.upload({ url, data });
    return { $promise: request };
  }

  getTransactionFileTypes() {
    return this.$resource(apis.invoiceItemFileTransaction + "types", null, {
      get: {
        isArray: true,
      },
    }).get();
  }

  getFiles(options) {
    return this.$resource(apis.invoiceItemFileTransaction).get(options);
  }

  getFile(id) {
    return this.$resource(apis.invoiceItemFileTransaction + id).get();
  }

  getCountryCities(id, countryId) {
    return this.$resource(
      `${apis.invoiceItemType}${id}/cities/${countryId}`,
      null,
      { get: { isArray: true } }
    ).get({ isCityRequired: false });
  }
}

export default InvoiceItemTypeResource;



// WEBPACK FOOTER //
// ./src/resources/invoiceItemType/invoiceItemType.resource.js